export default function convertToSnakeCase(value: string): string {
    return value?.toLowerCase().replaceAll(" ", "_")
}
